import vue from "vue";

import {
  getUserPage,
  getUserRelieve,
  getUserStart,
  getUserStop,
  updateUserPlatform,
  getUserDetails
} from "../../../services/systemUaer";

const state = {
  dataPages: [],
  total: 0,
  paginationInit: {current: 1, size: 10},
  filterInit: {},
  platformVisible: false,
  detailData: {},
};

const getters = {
  dataPages: () => state.dataPages,
  total: () => state.total,
  paginationInit: () => state.paginationInit,
  filterInit: () => state.filterInit,
  platformVisible: () => state.platformVisible,
  detailData: () => state.detailData,
};

const actions = {
  //分页
  getUserPage({commit, dispatch}, objc) {
    getUserPage({...state.filterInit, ...state.paginationInit}).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'dataPages', update: res.data.records});
        commit('updateState', {state: 'total', update: res.data.total})
      } else {
        commit('updateState', {state: 'dataPages', update: []});
        commit('updateState', {state: 'total', update: 0});
      }
    })
  },
  //启用
  getUserStart({commit, dispatch}, objc) {
    getUserStart(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getUserPage');
      }
    })
  },
  //停用
  getUserStop({commit, dispatch}, objc) {
    getUserStop(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getUserPage');
      }
    })
  },
  //解除关联
  getUserRelieve({commit, dispatch}, objc) {
    getUserRelieve(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getUserPage');
      }
    })
  },
  updateUserPlatform({commit, dispatch}, objc) {
    updateUserPlatform(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getUserPage');
        commit('updateState', {state: 'platformVisible', update: false});
      }
    })
  },
  getUserDetails({commit, dispatch}, objc) {
    getUserDetails(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'detailData', update: res.data});
      }
    })
  },
};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/system/modules/systemUser.js